import { ProductListing } from '@df/catalog-ui/listing/product-listing';
import { IProductDataV2, Product } from '@df/catalog/product/product';
import findLastIndex from 'lodash-es/findLastIndex';

export class ProductListingDecorator<T extends Product = Product<IProductDataV2>> extends ProductListing<T> {
    protected override getHasMore(): boolean {
        if (this.modelsFiltered) {
            const lastNonBannerIndex = findLastIndex(this.modelsFiltered, (model: Product<IProductDataV2>) => !model.data?.isBanner);
            return this.getLimit() < lastNonBannerIndex + 1;
        }
        return false;
    }
}
